module.exports = __webpack_public_path__ + "img/Energy.672ee7a1.png";